
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UICheckbox } from "components/ui";
import { SVGAsset } from "res";

import "./styles.css";

export default function PendingWireWidgetTableRow(props) {
    const oneTimeWireTransfer = props.oneTimeWireTransfer ?? {};
    const fundingAccount = `${ oneTimeWireTransfer.fundingAccount.number } - ${ oneTimeWireTransfer.fundingAccount.name }`;
    const payee = props.payee ?? "[payee]";
    //const fundingAccount = props.fundingAccount ?? "[fundingAccount]";
    const refNumber = props.refNumber ?? "[refNumber]";
    const reason = props.reason ?? "[reason]";
    const memo = props.reason ?? "[memo]";
    const amount = props.amount ?? "[amount]";
    const pendingApprovals = props.pendingApprovals ?? "[0]";
    const wireDate = props.wireDate ?? "[wireDate]";
    const initiatedBy = props.initiatedBy ?? "[initiatedBy]";
    const notifyPayee = oneTimeWireTransfer.notifyPayee ? "Yes" : "No";

    return (
        <TableItemContainer>
            <TableItemView className="ui-checkbox-column">
                <DisabledPrompt>
                    <UICheckbox label="" />
                </DisabledPrompt>
            </TableItemView>
                 <TableItemView className="ref-number-text">
                    <p className="detail-text ref-number">{ oneTimeWireTransfer.referenceNumber }</p>
                    <p className="detail-text approval-required-text">Approval Required By System</p>
                 </TableItemView>
            <TableItemView className="payee-text">
                <div className="text-container">
                    <p className="payee-detail detail">
                        <span className="detail-label">Payee: </span> <span className="detail-text">{ oneTimeWireTransfer.name }</span>
                    </p>
                    <p className="funding-account-detail detail">
                        <span className="detail-label">Funding Account: </span> <span className="detail-text">{ fundingAccount }</span>
                    </p>
                    <p className="ref-number-detail detail">
                        <span className="detail-label">Ref #: </span> <span className="detail-text">{ oneTimeWireTransfer.referenceNumber }</span>
                    </p>
                    
                    {/* Reason for payment detail row is shown if a reason is provided */}
                    { oneTimeWireTransfer.reasonForPayment !== "" && 
                    <p className="reason-detail detail">
                        <span className="detail-label">Reason for Payment: </span> <span className="detail-text">{ oneTimeWireTransfer.reasonForPayment }</span>
                    </p>
                    }
                    {/* Memo detail row is shown if a memo is provided */}
                    { oneTimeWireTransfer.memo !== "" && 
                    <p className="memo-detail detail">
                        <span className="detail-label">Memo: </span> <span className="detail-text">{ oneTimeWireTransfer.memo }</span>
                    </p>
                    }
                </div>
            </TableItemView>
            <TableItemTextView className="notify-payee-text" text={ notifyPayee } />
            <TableItemTextView className="amount-text" text={ oneTimeWireTransfer.amount.format() } />

            <TableItemView className="status-text">
                <div className="text-container">
                    <p className="status-detail detail">
                        <span className="detail-label">Pending Approval(s): </span><span className="detail-text">{ oneTimeWireTransfer.numberOfPendingApprovals }</span>
                    </p>
                </div>
            </TableItemView>
            <TableItemTextView className="wire-date" text={ oneTimeWireTransfer.date.format("m/d/Y") } />
            <TableItemTextView className="initiated-by-text" text={ oneTimeWireTransfer.initiatedBy } />
            <TableItemView className="comment-text">
                <textarea className="comment-text-area" />
            </TableItemView>
            <TableItemView className="actions-column">
                <DisabledPrompt>
                    <SVGAsset id="MagnifyingGlassIcon" className="magnifying-glass-icon clickable" />
                </DisabledPrompt>
                {/* <DisabledPrompt>
                    <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable" />
                </DisabledPrompt> */}

            </TableItemView>
        </TableItemContainer>
    )
}
